import React, { useState, useEffect, useRef } from 'react';
import { FaPaperPlane } from 'react-icons/fa';
import AUX from '../../../hoc/Aux_';
import { getSocketAPI } from '../../../Constant';
import { io } from 'socket.io-client';
import moment from 'moment';

const groupMessagesByDate = (messages) => {
  return messages.reduce((groups, message) => {
    const messageDate = moment(message.createdAt);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    let dateKey;
    if (messageDate.isSame(today, 'd')) {
      dateKey = 'Today';
    } else if (messageDate.isSame(yesterday, 'd')) {
      dateKey = 'Yesterday';
    } else {
      dateKey = messageDate.format('MMMM D, YYYY');
    }

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(message);
    return groups;
  }, {});
};

const AdminChats = () => {
  const chatContainerRef = useRef(null);
  const [socket, setSocket] = useState(null);
  const authToken = localStorage.getItem('loged_In_auth');
  const userId = localStorage.getItem('userId');

  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  function isMessageSent(messageId) {
    return messageId === userId;
  }

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      socket.emit('/chat/message/send', {
        message: newMessage,
      });

      const userMessage = {
        message: newMessage,
        fromId: userId,
        createdAt: new Date().toISOString(),
      };

      setMessages([...messages, userMessage]);
      setNewMessage('');
    }
  };

  useEffect(() => {
    if (userId && authToken) {
      const socketInstance = io(
        `${getSocketAPI()}/user?token=${authToken}&ownerId=${userId}`
      );

      setSocket(socketInstance);

      socketInstance.on('connect', () => {
        socketInstance.emit('/chat/message/list', {});
      });

      socketInstance.on('/chat/message/list', (response) => {
        setMessages((prevMessages) => [
          ...prevMessages,
          ...response?.data?.rows?.toReversed(),
        ]);
      });

      socketInstance.on('connect_error', (error) => {
        console.error('Socket connection error:', error, socketInstance);
      });

      socketInstance.on('/chat/message/receive', (response) => {
        setMessages((prevMessages) => [...prevMessages, response?.data]);
      });

      return () => {
        socketInstance.disconnect();
      };
    }
  }, [authToken, userId]);

  const groupedMessages = groupMessagesByDate(messages);

  return (
    <AUX>
      <div className="page-content-wrapper chat-box-container">
        <div
          style={{
            width: '100%',
            height: '50px',
            backgroundColor: 'rgb(13, 71, 161)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            fontSize: '18px',
            padding: '10px 16px',
          }}
        >
          Super Admin
        </div>

        <div
          ref={chatContainerRef}
          style={{
            height: 'calc(100vh - 262px)',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            padding: '10px',
          }}
        >
          {messages.length === 0 ? (
            <div
              style={{
                textAlign: 'center',
                color: '#888',
                marginTop: '20px',
              }}
            >
              No messages here to display
            </div>
          ) : (
            Object.entries(groupedMessages).map(([date, dateMessages]) => (
              <React.Fragment key={date}>
                <div
                  style={{
                    textAlign: 'center',
                    margin: '10px 0',
                    color: '#888',
                  }}
                >
                  {date}
                </div>
                {dateMessages.map((message, idx) => (
                  <div
                    key={idx}
                    style={{
                      alignSelf: isMessageSent(message.fromId)
                        ? 'flex-end'
                        : 'flex-start',
                      backgroundColor: isMessageSent(message.fromId)
                        ? 'rgb(13, 71, 161)'
                        : '#f9fbfe',
                      color: isMessageSent(message.fromId) ? 'white' : 'black',
                      borderRadius: '20px',
                      padding: '10px 15px',
                      margin: '5px',
                      minWidth: '125px',
                      maxWidth: '70%',
                    }}
                  >
                    <div>{message.message}</div>
                    <div
                      style={{
                        fontSize: '0.8em',
                        textAlign: 'right',
                        marginTop: '5px',
                        opacity: 0.7,
                      }}
                    >
                      {moment(message.createdAt).format('hh:mm A')}
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))
          )}
        </div>

        <div style={{ padding: '0 15px', marginTop: '10px' }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex' }}>
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Type your message..."
              style={{
                flexGrow: 1,
                marginRight: '10px',
                padding: '10px',
                borderRadius: '20px',
                border: '1px solid #ccc',
              }}
            />
            <button
              type="submit"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '20px',
                color: '#007bff',
              }}
            >
              <FaPaperPlane />
            </button>
          </form>
        </div>
      </div>
    </AUX>
  );
};

export default AdminChats;
